import { env } from "../config/env";
import { createClient } from "./http";

const inventoryApi = createClient(
  env.WAREHOUSE_INVENTORY_BASE_URL || env.AUTH_BASE_URL
);

export const orderPendingPaymentService = {
  closeUnclearPendingOrder(orderId, payload = {}) {
    if (!orderId) throw new Error("Customer order id is required");
    return inventoryApi.post(
      `/api/warehouse/customer-orders/${orderId}/close-unclear-pending`,
      payload
    );
  },
};
